import { DatePipe } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UploadedFileViewModel } from 'src/app/components/core/components/uploader/document_uploader.types';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { Tc, TcPerfilUsuarioEnum } from 'src/app/components/core/_infrastructure/types/common';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { DocumentosService } from './documentos.service';
import { SolicitudDocumentosAtestViewModel, TDocumentoSolicitudAtestFitoViewModel } from './documentos.types';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';

@Component({
    selector: 'app-documentos-edit-atestaciones',
    templateUrl: './documentos-edit.component.html',
})
export class DocumentosAtestEditComponent extends ComponentBase implements OnInit, OnDestroy {
    @HostListener('window:beforeunload', ['$event'])
    forceCheckUnload(): boolean {
        // Prevenimos la pérdida de datos, si el usuario recarga accidentalmente la página.
        // Lo controlamos y el navegador le requiere confirmación para finalizar la recarga.
        if (this.filePendingToPurge !== '') {
            this.documentosService.deleteFile(this.filePendingToPurge).subscribe();
        }
        return false;
    }

    editMode = false;
    editTitle = 'Nuevo';

    listPais$: Observable<Tc[]>;

    solicitudDocumentos: SolicitudDocumentosAtestViewModel;
    documento: TDocumentoSolicitudAtestFitoViewModel;
    uploadedFile: UploadedFileViewModel = new UploadedFileViewModel();

    cols: any[];

    //IdEstado: number;
    //IdEstadoDescripcion: string;
    //TipoSolicitudExDescripcion: string;

    RefAtestFito: string;
    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;
    codigoTipoSolicitud: string;
    IdEstadoSolicitudAtestFito: number;
    IdTipoSolicitudAtestFito: number;

    habilitarGuardar = true;

    visibilitySpinner = false;

    private filePendingToPurge = '';
    private docSaved = false;
    megaSizeLimit = 0;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public datepipe: DatePipe,
        private fb: UntypedFormBuilder,
        private navMenuService: NavMenuService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private documentosService: DocumentosService,
        protected configService: ConfigurationService,
    ) {
        super(authService, notificationService, exceptionHandler, configService);

        this.solicitudDocumentos = new SolicitudDocumentosAtestViewModel();
        this.documento = new TDocumentoSolicitudAtestFitoViewModel();
    }

    ngOnInit() {
        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento

        this.uploadedFile.OldGuidCollection = new Array<string>();

        this.createForm();

        let id = this.activatedRoute.snapshot.params['id'];
        let idDocumento = this.activatedRoute.snapshot.params['idDocumento'];

        this.guardRefreshPage(id);

        if (idDocumento) {
            this.documentosService.getDocumento(idDocumento).subscribe(result => {
                this.documento = result;

                this.IdTipoSolicitudAtestFito = this.documento.IdTipoSolicitudInfCa;
                this.tituloTipoSolicitud = this.documento.IdTipoSolicitudInfCaDescripcion;
                this.tituloEstadoSolicitud = this.documento.IdEstadoDescripcion;
                this.codigoTipoSolicitud = this.documento.CodigoTipoSolicitud;
                this.IdEstadoSolicitudAtestFito = this.documento.IdEstado;
                this.RefAtestFito = this.documento.RefAtestFito;

                this.uploadedFile = { ...this.uploadedFile, Guid: result.CodigoStorage, Name: result.NombreArchivo, Size: result.Size! };

                this.updateForm();

                //Si soy Inspector-Grabador
                //if (this.isGrabador && this.isInspector
                //    && this.documento.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_REVISION_SOLICITANTE) {
                //    this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_EXPORTACION, this.documento.IdEstadoSolicitudEx).Visible && this.laHeGrabadoYo;
                //}
                //else {
                this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ATESTACION, this.documento.IdEstado).Visible;
                //}

                if (!this.habilitarGuardar) {
                    this.DisableControlsConsulta();
                } else {
                    this.editMode = true;
                    this.editTitle = 'Editar';
                }
            });
        } else {
            this.documentosService.getAtestacionDocumentos(id).subscribe(result => {
                this.solicitudDocumentos = result;

                this.IdTipoSolicitudAtestFito = this.solicitudDocumentos.IdTipoSolicitudInfCa;
                this.tituloTipoSolicitud = this.solicitudDocumentos.IdTipoSolicitudInfCaDescripcion;
                this.tituloEstadoSolicitud = this.solicitudDocumentos.IdEstadoDescripcion;
                this.codigoTipoSolicitud = this.solicitudDocumentos.CodigoTipoSolicitud;
                this.IdEstadoSolicitudAtestFito = this.solicitudDocumentos.IdEstado;
                this.RefAtestFito = this.solicitudDocumentos.RefAtestFito;
            });
        }

        this.MegaSizeLimitsCargado$.subscribe(() => {
            this.megaSizeLimit = this.getValorSizeLimit('documentosAtest-edit');
        });
    }

    createForm() {
        this.form = this.fb.group({
            Texto: ['', Validators.required],
            NombreArchivo: ['', Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            Texto: this.documento.Texto,

            NombreArchivo: this.documento.NombreArchivo,
        });
    }

    private DisableControlsConsulta() {
        this.editTitle = 'Detalle';

        this.form.controls['Texto'].disable();

        this.form.controls['NombreArchivo'].disable();
    }

    private GetIdPerfilAtestFito(): number {
        if (this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.AgenteControl)) {
            return TcPerfilUsuarioEnum.AgenteControl;
        } else if (this.isCA) {
            return TcPerfilUsuarioEnum.ComunidadAutonoma;
        } else {
            return TcPerfilUsuarioEnum.Solicitante;
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/atestacion/documentos', this.navMenuService.currentSolicitudAtestacion.Id]);
    }

    onFileUploaded(uploadedFile: UploadedFileViewModel) {
        this.uploadedFile = uploadedFile;

        if (this.filePendingToPurge !== '') {
            this.documentosService.deleteFile(this.filePendingToPurge).subscribe();
        }
        this.filePendingToPurge = uploadedFile.Guid;

        this.addSuccessMessage('Documento cargado. Recuerde GUARDAR antes de abandonar la pantalla');
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos del documento');
            return;
        }
        //Validamos si se ha cargado el documento:
        if (this.uploadedFile === null || this.uploadedFile.Name === null) {
            this.addErrorMessage('Debe cargar el documento antes de guardar');
            return;
        }

        this.visibilitySpinner = true;

        let documento = new TDocumentoSolicitudAtestFitoViewModel();

        //documento.Fecha = this.form.value.Fecha;
        documento.Texto = this.form.value.Texto;

        //documento.VisibleInspector = this.esInspector ? !this.form.value.VisibleInspector : false;

        //documento.VisibleInspector = this.editMode ? documento.VisibleInspector :
        //    (!this.isInspector || (this.isGrabador && this.isInspector && this.laHeGrabadoYo)) ? false : true;

        documento.IdSolicitudAtestFito = this.navMenuService.currentSolicitudAtestacion.Id;

        documento.Id = this.documento.Id;

        documento.NombreArchivo = this.uploadedFile.Name;
        documento.OldCodigoStorageCollection = this.uploadedFile.OldGuidCollection;
        documento.CodigoStorage = this.uploadedFile.Guid;
        documento.Size = this.uploadedFile.Size;
        documento.IdUsuario = this.loggedInUser!.Id;
        documento.IdPerfilAtestFito = this.GetIdPerfilAtestFito();

        if (this.editMode) {
            this.documentosService.editDocumento(documento).subscribe({
                next: () => {
                    this.addSuccessMessage('Documento modificado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                    this.docSaved = true;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.documentosService.createDocumento(documento).subscribe({
                next: () => {
                    this.addSuccessMessage('Documento añadido correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                    this.docSaved = true;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    ngOnDestroy(): void {
        if (this.filePendingToPurge !== '' && !this.docSaved) {
            this.documentosService.deleteFile(this.filePendingToPurge).subscribe();
        }
    }
}
